interface TitleSectionProps {
  first_title: string;
  second_tilte?: string;
  description?: string;
  blueToRed: boolean;
}

export const TitleSection: React.FC<TitleSectionProps> = ({
  blueToRed,
  first_title,
  second_tilte,
  description,
}) => {
  return (
    <div className="text-center my-8">
      <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold">
        {blueToRed ? (
          <>
            <span className="text-primary">{first_title}</span>{" "}
            <span className="text-primary-red">{second_tilte}</span>
          </>
        ) : (
          <>
            <span className="text-primary-red">{first_title}</span>{" "}
            <span className="text-primary">{second_tilte}</span>
          </>
        )}
      </h1>
      {description && (
        <p className="text-sm text-left md:text-base text-gray-600 leading-relaxed mt-4">
          {description}
        </p>
      )}
    </div>
  );
};
